import md5 from 'crypto-js/md5'

class FilterStore {
  constructor (organizerToken, urlPath) {
    this.storageIndex = 'filters:' + md5(organizerToken + '|' + urlPath)
  }
  
  retrieve () {
    return JSON.parse(localStorage.getItem(this.storageIndex))
  }
  
  save (key, value) {
    let storedFilters = this.retrieve() 
    if (!storedFilters) storedFilters = {}
    storedFilters[key] = value
    localStorage.setItem(this.storageIndex, JSON.stringify(storedFilters))
  }

  clear () {
      localStorage.removeItem(this.storageIndex)
  } 
  
  merge (originalFilters) {
    return {
      ...originalFilters,
      ...this.retrieve()
    }
  }
}

export default FilterStore;